import brandPortalMessages from "@faire/web-api/routes/brand-portal/messages";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../../common/Bold";
export var SWFShipped = function SWFShipped() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "ha1Fly",
    defaultMessage: [{
      "type": 0,
      "value": "Deze bestelling is gemarkeerd als verzonden. Je kunt de trackinginformatie dus niet langer bewerken. Wanneer een label dat werd aangemaakt met Verzenden met Faire al is gebruikt of wanneer de zending al onderweg is, kun je het label niet annuleren en dus ook geen nieuwe aanmaken. Neem contact op met ons supportteam voor hulp, zodat je retailer de juiste informatie krijgt."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "u33Ad+",
    defaultMessage: [{
      "type": 0,
      "value": "Bovendien kun je via "
    }, {
      "children": [{
        "type": 0,
        "value": "Faire Messenger"
      }],
      "type": 8,
      "value": "ButtonFormatting"
    }, {
      "type": 0,
      "value": " een bericht naar de retailer sturen om de juiste verzendinformatie te verstrekken."
    }],
    values: {
      ButtonFormatting: function ButtonFormatting(chunks) {
        return FaireMessagingFormatting(chunks);
      }
    }
  })));
};
var FaireMessagingFormatting = function FaireMessagingFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalMessages(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};